import { selectUpgradeView } from './upgrade-options'

const opt = (id, name, price) => ({ id, name, prices: [{ price }] })
const SUPER = opt(1, 'A- Super Session', 79.95)
const DELUXE = opt(2, 'B- Deluxe Session', 59.95)
const STANDARD = opt(3, 'C- Standard Session', 49.95)
const ECONOMY = opt(5, 'E- Economy Session', 29.95)
const UPGRADE_PRODUCT = opt(9, 'Upgrade Economy to Deluxe', 30) // /upgrade/ PRODUCT
const SESSIONS = [SUPER, DELUXE, STANDARD, ECONOMY]

describe('selectUpgradeView', () => {
  it('new customer (no prior purchase) is not returning -> new-booking grid', () => {
    const r = selectUpgradeView({ options: SESSIONS, priorOrderPackage: null })
    expect(r.isReturning).toBe(false)
    expect(r.sessions).toHaveLength(4)
  })

  it('returning customer is detected from the prior PURCHASE, even with NO /upgrade/ products', () => {
    // This is the bug the fix addresses: the email filter strips /upgrade/ products,
    // so options are sessions only -- yet a returning student must still see upgrades.
    const r = selectUpgradeView({ options: SESSIONS, priorOrderPackage: { optionId: 5 } }) // Economy
    expect(r.isReturning).toBe(true)
    expect(r.priorOption).toBe(ECONOMY)
    expect(r.priorPrice).toBe(29.95)
    // All higher tiers offered, best -> worst.
    expect(r.offeredUpgrades.map((o) => o.id)).toEqual([1, 2, 3]) // Super, Deluxe, Standard
  })

  it('a staff-sent link narrows the offer to just the chosen tier', () => {
    const r = selectUpgradeView({
      options: SESSIONS,
      priorOrderPackage: { optionId: 5 }, // Economy
      preselectUpgradeId: 2, // staff chose Deluxe
    })
    expect(r.isReturning).toBe(true)
    expect(r.staffPick).toBe(DELUXE)
    expect(r.offeredUpgrades).toEqual([DELUXE]) // only the chosen upgrade
    // Customer pays the difference: Deluxe 59.95 - Economy 29.95 (computed in onSelectUpgrade).
    expect(r.priorPrice).toBe(29.95)
  })

  it('falls back to all upgrades when the preselected tier is not an eligible upgrade', () => {
    const r = selectUpgradeView({
      options: SESSIONS,
      priorOrderPackage: { optionId: 2 }, // Deluxe (rank 2)
      preselectUpgradeId: 5, // Economy is LOWER -> not an upgrade
    })
    expect(r.staffPick).toBeNull()
    expect(r.offeredUpgrades.map((o) => o.id)).toEqual([1]) // only Super is above Deluxe
  })

  it('ignores /upgrade/ PRODUCT options when offering upgrades (uses session tiers)', () => {
    const r = selectUpgradeView({
      options: [...SESSIONS, UPGRADE_PRODUCT],
      priorOrderPackage: { optionId: 5 }, // Economy
    })
    expect(r.offeredUpgrades).not.toContain(UPGRADE_PRODUCT)
    expect(r.offeredUpgrades.every((o) => !/upgrade/i.test(o.name))).toBe(true)
  })

  it('preview mode is returning without a prior purchase', () => {
    const r = selectUpgradeView({ options: [...SESSIONS, UPGRADE_PRODUCT], previewReturning: true })
    expect(r.isReturning).toBe(true)
  })
})
